import React from 'react';
import PropTypes from 'prop-types';
import { GlobalNavigation } from '../responsive/organisms/GlobalNavigation';
import { MainNavigation } from '../responsive/organisms/MainNavigation';

export const Header = ({ content }) => (
  <>
    <GlobalNavigation />
    <MainNavigation content={content} />
  </>
);

Header.propTypes = {
  content: PropTypes.objectOf(PropTypes.any)
};
